import {Component, Input} from '@angular/core';
import {NgClass} from "@angular/common";

@Component({
  selector: 'form-button',
  standalone: true,
    imports: [
        NgClass
    ],
  templateUrl: './form-button.component.html',
  styleUrl: './form-button.component.scss'
})
export class FormButtonComponent {
    @Input({ required: true }) subtitle!: string;
    @Input() btnType!: 'cancel' | 'confirm' | 'danger';
}
